import React from 'react'
import { pick } from 'lodash'

import Entry from './Entry'

const CommentsList = ({ items = [] }) => !items.length ? null : (
  <div className='Comments__list'>
    {items.map((el = {}, i) => <Entry key={i} name={el.user.name} {...pick(el, [ 'text', 'created' ])} />)}
  </div>
)

export default CommentsList



// WEBPACK FOOTER //
// ./src/components/Comments/List.jsx